// extracted by mini-css-extract-plugin
export default {"wmndsbtninline":"Stats_wmndsbtninline__ms1Uk"};